<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '94vw', maxWidth: '1040px' }"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header"><span>{{ 'DEVIATION_QR_ADMIN.TITLE' | translate }}</span></ng-template>

  <div class="qr-admin">
    <p class="qr-admin__intro">{{ 'DEVIATION_QR_ADMIN.INTRO' | translate }}</p>

    <div class="qr-admin__layout">
      <section class="qr-admin__codes" aria-labelledby="qr-admin-codes">
        <h3 id="qr-admin-codes" class="qr-admin__heading">{{ 'DEVIATION_QR_ADMIN.CODES_HEADING' | translate }}</h3>

        <div class="table-responsive">
          <table class="table qr-admin__table">
            <thead>
              <tr>
                <th scope="col">{{ 'DEVIATION_QR_ADMIN.COLUMN_FOR' | translate }}</th>
                <th scope="col">{{ 'DEVIATION_QR_ADMIN.COLUMN_STATUS' | translate }}</th>
                <th scope="col">{{ 'DEVIATION_QR_ADMIN.COLUMN_EXPIRES' | translate }}</th>
                <th scope="col" class="text-right">{{ 'DEVIATION_QR_ADMIN.COLUMN_REPORTS' | translate }}</th>
                <th scope="col"><span class="sr-only">{{ 'DEVIATION_QR_ADMIN.COLUMN_ACTIONS' | translate }}</span></th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row.key) {
                <tr [class.qr-admin__row--selected]="row.key === selectedKey">
                  <td>
                    @if (isLive(row)) {
                      <button type="button" class="btn btn-link qr-admin__name" (click)="select(row)"
                        [attr.aria-pressed]="row.key === selectedKey">{{ row.name }}</button>
                    } @else {
                      <span class="qr-admin__name">{{ row.name }}</span>
                    }
                    <span class="qr-admin__kind">
                      {{ (row.item.BusinessDepartmentId === null ? 'DEVIATION_QR_ADMIN.BUSINESS_WIDE' : 'DEVIATION_QR_ADMIN.DEPARTMENT') | translate }}
                    </span>
                  </td>
                  <td>
                    <span class="qr-admin__status" [attr.data-status]="row.status">
                      @switch (row.status) {
                        @case ('valid') { <i class="fa fa-check-circle" aria-hidden="true"></i>{{ 'DEVIATION_QR_ADMIN.STATUS_VALID' | translate }} }
                        @case ('expiring') { <i class="fa fa-hourglass-half" aria-hidden="true"></i>{{ 'DEVIATION_QR_ADMIN.STATUS_EXPIRING' | translate }} }
                        @case ('expired') { <i class="fa fa-exclamation-circle" aria-hidden="true"></i>{{ 'DEVIATION_QR_ADMIN.STATUS_EXPIRED' | translate }} }
                        @default { <i class="fa fa-circle-o" aria-hidden="true"></i>{{ 'DEVIATION_QR_ADMIN.STATUS_NONE' | translate }} }
                      }
                    </span>
                  </td>
                  <td class="qr-admin__mono">{{ expiryText(row) }}</td>
                  <td class="qr-admin__mono text-right">{{ row.item.QrCode ? row.item.DeviationCountLast30Days : '—' }}</td>
                  <td class="qr-admin__actions">
                    @if (isLive(row)) {
                      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="askRevoke(row)">
                        <i class="fa fa-ban" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.REVOKE' | translate }}
                      </button>
                    } @else {
                      <button type="button" class="btn btn-outline-primary btn-sm" (click)="openCreate(row)">
                        <i class="pi pi-plus" aria-hidden="true"></i>
                        {{ (row.status === 'expired' ? 'DEVIATION_QR_ADMIN.CREATE_NEW' : 'DEVIATION_QR_ADMIN.CREATE') | translate }}
                      </button>
                    }
                  </td>
                </tr>

                @if (creatingKey === row.key) {
                  <tr class="qr-admin__panel-row">
                    <td colspan="5">
                      <div class="qr-admin__panel">
                        <div class="qr-admin__field">
                          <label [for]="'qr-expiry-' + row.key">{{ 'DEVIATION_QR_ADMIN.EXPIRY_LABEL' | translate }}</label>
                          <p-datepicker [inputId]="'qr-expiry-' + row.key" [(ngModel)]="expirationDate" [showClear]="true"
                            [minDate]="minDate" appendTo="body" dateFormat="dd.mm.yy" [showIcon]="true"></p-datepicker>
                          <small class="qr-admin__hint">{{ 'DEVIATION_QR_ADMIN.EXPIRY_HINT' | translate }}</small>
                        </div>
                        <div class="qr-admin__panel-actions">
                          <button type="button" class="btn btn-secondary" (click)="cancelCreate()">{{ 'DEVIATION_QR_ADMIN.CANCEL' | translate }}</button>
                          <button type="button" class="btn btn-success" (click)="create(row)">
                            <i class="pi pi-plus" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.CREATE' | translate }}
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                }

                @if (revokingKey === row.key) {
                  <tr class="qr-admin__panel-row">
                    <td colspan="5">
                      <div class="qr-admin__panel" role="alertdialog" [attr.aria-label]="'DEVIATION_QR_ADMIN.REVOKE' | translate">
                        <p class="qr-admin__warning">
                          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                          {{ 'DEVIATION_QR_ADMIN.REVOKE_CONFIRM' | translate: { name: row.name } }}
                        </p>
                        <div class="qr-admin__panel-actions">
                          <button type="button" class="btn btn-secondary" (click)="cancelRevoke()">{{ 'DEVIATION_QR_ADMIN.KEEP' | translate }}</button>
                          <button type="button" class="btn btn-danger" (click)="revoke(row)">
                            <i class="fa fa-ban" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.REVOKE_CONFIRM_BUTTON' | translate }}
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
        <p class="qr-admin__hint">{{ 'DEVIATION_QR_ADMIN.REPORTS_NOTE' | translate }}</p>
      </section>

      <aside class="qr-admin__preview" aria-labelledby="qr-admin-preview">
        @if (selectedRow; as row) {
          <h3 id="qr-admin-preview" class="qr-admin__heading">{{ row.name }}</h3>
          <div class="qr-admin__code">
            <!-- Rendered at print size and shown smaller, so the PNG and the poster stay sharp -->
            <qrcode #qrCode [qrdata]="row.item.QrCode?.QrCodeUrl" [width]="1024" [margin]="2"
              [errorCorrectionLevel]="'M'" [elementType]="'canvas'"></qrcode>
          </div>
          <p class="qr-admin__mono qr-admin__url">{{ row.item.QrCode?.QrCodeUrl }}</p>
          <div class="qr-admin__downloads">
            <button type="button" class="btn btn-primary" (click)="printPoster('A4')">
              <i class="pi pi-print" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.POSTER_A4' | translate }}
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="printPoster('A5')">
              <i class="pi pi-print" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.POSTER_A5' | translate }}
            </button>
            <button type="button" class="btn btn-outline-secondary" (click)="downloadPng()">
              <i class="pi pi-download" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.PNG' | translate }}
            </button>
          </div>
        } @else {
          <h3 id="qr-admin-preview" class="qr-admin__heading">{{ 'DEVIATION_QR_ADMIN.PREVIEW_HEADING' | translate }}</h3>
          <p class="qr-admin__hint">{{ 'DEVIATION_QR_ADMIN.PREVIEW_EMPTY' | translate }}</p>
        }
      </aside>
    </div>

    <section class="qr-admin__case-types" aria-labelledby="qr-admin-case-types">
      <h3 id="qr-admin-case-types" class="qr-admin__heading">{{ 'DEVIATION_QR_ADMIN.CASE_TYPES_HEADING' | translate }}</h3>
      <p class="qr-admin__hint">{{ 'DEVIATION_QR_ADMIN.CASE_TYPES_INTRO' | translate }}</p>
      @if (noCaseTypeIsPublic) {
        <p class="qr-admin__warning" role="alert">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ 'DEVIATION_QR_ADMIN.CASE_TYPES_NONE_PUBLIC' | translate }}
        </p>
      }
      @if (caseTypes.length === 0 && !isLoading) {
        <p>{{ 'DEVIATION_QR_ADMIN.CASE_TYPES_EMPTY' | translate }}</p>
      }
      <ul class="qr-admin__case-type-list">
        @for (caseType of caseTypes; track caseType.Id) {
          <li>
            <label class="qr-admin__check">
              <input type="checkbox" [checked]="caseType.IsPublic" [disabled]="savingCaseTypeIds.has(caseType.Id)"
                (change)="toggleCaseType(caseType, $event)" />
              <span>{{ caseType.Name }}</span>
            </label>
          </li>
        }
      </ul>
    </section>
  </div>
</p-dialog>

<kuba-busy [busy]="isLoading" message="PROCESSING"></kuba-busy>
